export const formatDinheiro = (value, p = 2) => {
  return new Intl.NumberFormat('pt-br', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: p,
  }).format(value);
};
